module.exports = __webpack_public_path__ + "static/media/img-cmpj.62341f0b.png";